import React from 'react';

const Ic = ({ d, sz = 16, s = 'currentColor', f = 'none', ...p }) => (
  <svg width={sz} height={sz} viewBox="0 0 24 24" fill={f} stroke={s}
    strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" {...p}>
    <path d={d} />
  </svg>
);

const Icons = {
  Sparkle: p => <Ic {...p} d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456z" f="currentColor" s="none" />,

  Upload: p => <Ic {...p} d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />,

  Menu: p => <Ic {...p} d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />,

  Wand: p => <Ic {...p} d="M15.042 21.672L13.684 16.6m0 0l-2.51 2.225.569-9.47 5.227 7.917-3.286-.672zM12 2.25V4.5m5.834.166l-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243l-1.59-1.59" />,

  Img: p => <Ic {...p} d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />,

  Vid: p => <Ic {...p} d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z" />,

  Grid: p => <Ic {...p} d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z" />,

  Coin: () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M12 7v10M9.5 9.5C9.5 8.4 10.6 8 12 8s2.5.5 2.5 1.5-1 1.5-2.5 1.8c-1.7.3-2.5 1-2.5 2.2 0 1.1 1.1 1.5 2.5 1.5s2.5-.5 2.5-1.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,

  X: p => <Ic {...p} d="M6 18L18 6M6 6l12 12" />,
  Help: p => <Ic {...p} d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />,
  Check: p => <Ic {...p} d="M4.5 12.75l6 6 9-13.5" />,
  DL: p => <Ic {...p} d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />,
  Refresh: p => <Ic {...p} d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />,

  Trash: p => <Ic {...p} d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />,

  Play: p => <Ic {...p} d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" f="currentColor" s="none" />,

  Plus: p => <Ic {...p} d="M12 4.5v15m7.5-7.5h-15" />,
  Minus: p => <Ic {...p} d="M5 12h14" />,

  Crown: p => <Ic {...p} d="M2.25 18.75L3.5 7.5l4.5 4.5L12 4.5l4 7.5 4.5-4.5L21.75 18.75H2.25z" f="currentColor" s="none" />,

  User: p => <Ic {...p} d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />,

  Logout: p => <Ic {...p} d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75" />,

  Edit: p => <Ic {...p} d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />,

  Film: p => <Ic {...p} d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-2.625 0V5.625m0 0A1.125 1.125 0 014.5 4.5h15a1.125 1.125 0 011.125 1.125m-17.25 0v1.5c0 .621.504 1.125 1.125 1.125M19.5 4.5v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5" />,

  Audio: p => <Ic {...p} d="M19.114 5.636a9 9 0 010 12.728M16.463 8.288a5.25 5.25 0 010 7.424M6.75 8.25l4.72-4.72a.75.75 0 011.28.53v15.88a.75.75 0 01-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.01 9.01 0 012.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75z" />,

  // -- App-specific functional icons ----------------------------------------

  // Film strip (professional video loader icon)
  FilmStrip: ({ sz = 24, ...p }) => (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <rect x="2" y="2" width="20" height="20" rx="2.5"/>
      <line x1="7" y1="2" x2="7" y2="22"/>
      <line x1="17" y1="2" x2="17" y2="22"/>
      <line x1="2" y1="7" x2="7" y2="7"/>
      <line x1="2" y1="17" x2="7" y2="17"/>
      <line x1="17" y1="7" x2="22" y2="7"/>
      <line x1="17" y1="17" x2="22" y2="17"/>
    </svg>
  ),

  Clapperboard: ({ sz = 24, ...p }) => (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M4 7h16v11.5A2.5 2.5 0 0 1 17.5 21h-11A2.5 2.5 0 0 1 4 18.5V7z"/>
      <path d="M4 7 6.3 3h4L8 7"/>
      <path d="M10.8 7 13.1 3h4L14.8 7"/>
      <path d="M17.6 7 20 3"/>
      <path d="M4 12h16"/>
    </svg>
  ),

  // Motion sync - person in motion with orbit arc
  Motion: ({ sz = 24, ...p }) => (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="12" cy="4.5" r="1.5"/>
      <path d="M8 8.5c1.5-1 2.5-1.5 4-1.5s2.8.6 4 1.5"/>
      <path d="M9 12l-2 4h10l-2-4"/>
      <path d="M9 12l1.5-3.5h3L15 12"/>
      <path d="M7 16l-1 3M17 16l1 3"/>
      <path d="M5 11a8 8 0 0 0 4 7"/>
      <path d="M19 11a8 8 0 0 1-4 7"/>
    </svg>
  ),

  // Camera orbit / different angles
  Orbit: ({ sz = 24, ...p }) => (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="12" cy="12" r="3"/>
      <ellipse cx="12" cy="12" rx="10" ry="4" transform="rotate(-30 12 12)"/>
      <ellipse cx="12" cy="12" rx="10" ry="4" transform="rotate(30 12 12)"/>
    </svg>
  ),

  // Lip sync - mouth waveform
  LipSync: ({ sz = 24, ...p }) => (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 3a9 9 0 1 0 0 18A9 9 0 0 0 12 3z"/>
      <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
      <line x1="9" y1="10" x2="9.01" y2="10" strokeWidth="2"/>
      <line x1="15" y1="10" x2="15.01" y2="10" strokeWidth="2"/>
    </svg>
  ),

  // Upscale / magnify-enhance
  Upscale: ({ sz = 24, ...p }) => (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="10" cy="10" r="7"/>
      <line x1="21" y1="21" x2="15.8" y2="15.8"/>
      <path d="M7 10h6M10 7v6"/>
    </svg>
  ),

  // Pencil / prompt writer
  PenBox: ({ sz = 24, ...p }) => (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 20h9"/>
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
      <path d="M15 5l3 3"/>
    </svg>
  ),

  // Multi-shot / film frames
  Multishot: ({ sz = 24, ...p }) => (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <rect x="2" y="6" width="14" height="12" rx="2"/>
      <path d="M22 8.5l-4 2.5 4 2.5V8.5z" fill="currentColor" stroke="none"/>
      <line x1="6" y1="6" x2="6" y2="18"/>
      <line x1="10" y1="6" x2="10" y2="18"/>
    </svg>
  ),

  // Recreate / refresh-image
  Recreate: ({ sz = 24, ...p }) => (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M3 7v6h6"/>
      <path d="M3 13A9 9 0 1 0 6.2 6.2L3 10"/>
      <path d="M12 8v4l3 3"/>
    </svg>
  ),

  // Variation / grid-sparkle
  Variation: ({ sz = 24, ...p }) => (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <rect x="2" y="2" width="8" height="8" rx="1.5"/>
      <rect x="14" y="2" width="8" height="8" rx="1.5"/>
      <rect x="2" y="14" width="8" height="8" rx="1.5"/>
      <rect x="14" y="14" width="8" height="8" rx="1.5"/>
    </svg>
  ),

  // Portrait / image frame outline (used as image loader - matches -- style)
  ImgFrame: ({ sz = 24, ...p }) => (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <rect x="3" y="3" width="18" height="18" rx="2"/>
      <circle cx="8.5" cy="8.5" r="1.5"/>
      <path d="M21 15l-5-5L5 21"/>
    </svg>
  ),

  // Waveform / audio-lip
  Waveform: ({ sz = 24, ...p }) => (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M2 12h2M6 6v12M10 9v6M14 4v16M18 7v10M22 12h-2"/>
    </svg>
  ),

  // Scissors - Edit Video
  Scissors: ({ sz = 24, ...p }) => (
    <svg width={sz} height={sz} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="6" cy="6" r="3"/>
      <circle cx="6" cy="18" r="3"/>
      <line x1="20" y1="4" x2="8.12" y2="15.88"/>
      <line x1="14.47" y1="14.48" x2="20" y2="20"/>
      <line x1="8.12" y1="8.12" x2="12" y2="12"/>
    </svg>
  ),

  // -- Brand Logos (Custom PNGs) -------------------------------------------

  G: p => <img src="/google.png" width={p.sz||18} height={p.sz||18} style={{ objectFit: 'contain' }} alt="Google" />,
  Gemini: p => <img src="/gemini.png" width={p.sz||18} height={p.sz||18} style={{ objectFit: 'contain' }} alt="Gemini" />,
  Flux: p => <img src="/flux.png" width={p.sz||18} height={p.sz||18} style={{ objectFit: 'contain' }} alt="Flux" />,
  Kling: p => <img src="/kling.png" width={p.sz||18} height={p.sz||18} style={{ objectFit: 'contain' }} alt="Kling" />,
  Grok: p => <img src="/grok.png" width={p.sz||18} height={p.sz||18} style={{ objectFit: 'contain' }} alt="Grok" />,
  OpenAI: p => <img src="/openai.png" width={p.sz||18} height={p.sz||18} style={{ objectFit: 'contain' }} alt="OpenAI" />,
  Seedream: p => <img src="/seedream.png" width={p.sz||18} height={p.sz||18} style={{ objectFit: 'contain' }} alt="Seedream" />,
  SD: p => <img src="/sd.png" width={p.sz||18} height={p.sz||18} style={{ objectFit: 'contain' }} alt="Stability" />,
  Wan: p => <img src="/wan.png" width={p.sz||18} height={p.sz||18} style={{ objectFit: 'contain' }} alt="Wan" />,
  Banana: p => <img src="/banana.png" width={p.sz||18} height={p.sz||18} style={{ objectFit: 'contain' }} alt="Banana" />,
  Qwen: p => <img src="/Qwen.png" width={p.sz||18} height={p.sz||18} style={{ objectFit: 'contain' }} alt="Qwen" />,
  Recraft: p => <img src="/recraft.png" width={p.sz||18} height={p.sz||18} style={{ objectFit: 'contain' }} alt="Recraft" />,
  Topaz: p => <img src="/topaz.png" width={p.sz||18} height={p.sz||18} style={{ objectFit: 'contain' }} alt="Topaz" />,
  GPT: p => <img src="/GPT.png" width={p.sz ? p.sz + 10 : 32} height={p.sz ? p.sz + 10 : 32} style={{ objectFit: 'contain', transform: 'scale(1.1)' }} alt="GPT" />,
};

export default Icons;
